import { useSelector, useDispatch } from 'react-redux'
import { getMyData } from '../../features/profile/profileSlice'  
import { setViewLanguageModal } from '../../features/auth/authSlice'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'
import FlagCircleIcon from '@mui/icons-material/FlagCircle';
import GroupIcon from '@mui/icons-material/Group';
import FolderSharedIcon from '@mui/icons-material/FolderShared';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import { useNavigate } from 'react-router-dom'
import { setSettingSection, setViewReportIssueModal } from 'features/settings/settingSlice'
import Loader from "loaders/Loader";
import {  SettingsItemWrapper, SettingsLi } from './settings.styled'
import { useEffect } from 'react';
import PreviewIcon from '@mui/icons-material/Preview'; 
import { FaMoneyBillTransfer } from "react-icons/fa6";
import TranslateIcon from '@mui/icons-material/Translate';

import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useTranslation } from 'react-i18next';

function SettingsComponent(props) {
  const { t: translate } = useTranslation()

    const location = useLocation();
    const section =  new URLSearchParams(location.search).get('section') ? new URLSearchParams(location.search).get('section') : 'profile'
  
    const { user, viewLanguageModal } = useSelector((state) => state.auth)
    const { profile, isLoading } = useSelector((state) => state.profile)


    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { t: navigationT } = useTranslation('navigation')
    if (!profile) {  dispatch(getMyData()) }
    
    const handleSettingsNav = (value) => {
        navigate(`/settings?section=${value}`)
        dispatch(setSettingSection(value))
    }

    const handleLanguageModal = () => { 
        dispatch(setViewLanguageModal(true))
    }

    const handleSettingsReport = () => {
        dispatch(setViewReportIssueModal(true))
    }

    useEffect(() => {
        console.log('section: ' + section)
    }, [section])

    return (
        <SettingsListContainer>
            {isLoading ? 
                (
                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                        <Loader />   
                        
                    </div>
                ) 
                : 
                (
                    <SettingsWrap>
                        <SettingsTitle>
                            {translate("web:settings.settings")}
                        </SettingsTitle>
                        <SettingsItemWrapper>

                            {
                                user.isOrganization && (
                                    <SettingsLi
                                        active={section === "features"}
                                        onClick={() => handleSettingsNav('features')} >
                                        <ToggleOnIcon />
                                        <SettingsItemTitle >
                                            {translate("web:settings.featureSettings")}
                                        </SettingsItemTitle>
                                    </SettingsLi>
                                    
                                )
                            }
                            <SettingsLi 
                                active={section === "profile"}
                                onClick={() => handleSettingsNav('profile')}>
                                <AccountCircleIcon />
                                <SettingsItemTitle>
                                    {translate("web:settings.profile")}
                                </SettingsItemTitle>   
                            </SettingsLi>

                            <SettingsLi 
                                active={section === "memberships"}
                                onClick={() => handleSettingsNav('memberships')} >
                                <GroupIcon />
                                {user.isOrganization ? (
                                    <SettingsItemTitle >
                                        {
                                            translate("web:settings.members")
                                        }
                                    </SettingsItemTitle>  
                                ):
                                (
                                    <SettingsItemTitle >
                                        {
                                            translate("web:settings.memberships")
                                        }
                                    </SettingsItemTitle>  
                                )}
                            </SettingsLi>
                            {user.isOrganization ? (
                                <>
                                    <SettingsLi 
                                        active={section === "viewSettings"}
                                        onClick={() => handleSettingsNav('viewSettings')}> 
                                        <PreviewIcon />
                                        <SettingsItemTitle><nobr>
                                            {translate("web:settings.viewSettings")}
                                            </nobr> </SettingsItemTitle>   
                                    </SettingsLi> 
                                </>
                            )
                            :
                            (
                                <SettingsLi 
                                    active={section === "requests"}
                                    onClick={() => handleSettingsNav('requests')} >
                                    <GroupAddIcon />
                                    <SettingsItemTitle>
                                        {translate("web:settings.requests")}
                                    </SettingsItemTitle>   
                                </SettingsLi>
                            )
                            }

                            {!user.isOrganization &&
                                // (
                                //     <SettingsLi onClick={() => handleSettingsNav('myChurchDirectory')}>
                                //         <FolderSharedIcon />
                                //         <SettingsItemTitle><nobr>
                                //                 {
                                //                     translate('church:directory.title')
                                //                 }
                                //             </nobr></SettingsItemTitle> 
                                //     </SettingsLi>
                                // )
                                // :
                                (
                                    <SettingsLi 
                                        active={section === "directory"}
                                        onClick={() => handleSettingsNav('directory')}>
                                        <FolderSharedIcon />
                                        <SettingsItemTitle>
                                            <nobr>
                                                {
                                                    translate("web:settings.myDirectoryItem")
                                                }
                                            </nobr></SettingsItemTitle> 
                                    </SettingsLi>
                                )
                            }

                            {
                                !user.isOrganization && (
                                    <SettingsLi 
                                        active={section === "giving"}
                                        onClick={() => handleSettingsNav('giving')} >
                                        <FaMoneyBillTransfer fontSize={'26px'} />
                                        <SettingsItemTitle >
                                            {translate("web:settings.giving")}
                                        </SettingsItemTitle>  
                                    </SettingsLi>
                                )
                            }

                            {
                                user.isOrganization && (
                                    <SettingsLi 
                                        active={section === "giving"}
                                        onClick={() => handleSettingsNav('giving')} >
                                        <FaMoneyBillTransfer fontSize={'26px'} /> 
                                        <SettingsItemTitle >
                                            {translate("web:settings.memberGiving")}
                                        </SettingsItemTitle>  
                                    </SettingsLi>
                                )
                            }

                        </SettingsItemWrapper>
                    </SettingsWrap>
                )}
                           
                <SettingsLi  onClick={handleLanguageModal}>
                    <TranslateIcon/>
                    <SettingsItemTitle>
                        {navigationT('language')}
                    </SettingsItemTitle>  
                </SettingsLi>

                <SettingsLi  onClick={handleSettingsReport}>
                    <FlagCircleIcon/>
                    <SettingsItemTitle>
                        {
                            translate("web:settings.report")
                        }
                    </SettingsItemTitle>  
                </SettingsLi>

        </SettingsListContainer>
    )
}

export default SettingsComponent

const SettingsLiInvite = styled(SettingsLi)`
    background-color: white;
    color: var(--themeColor);
    border: 3px solid var(--themeColor);
    /* background-color: var(--themeColor);
    color: white;
    border: 3px solid var(--themeColor); */

    &:hover {
        background-color: var(--themeColor);
        color: white;
        border: 3px solid var(--themeColor);
        /* background-color: white;
        color: var(--themeColor);
        border: 3px solid var(--themeColor); */
    }

`


const SettingsListContainer = styled.div`
    width: 259px;
    min-width: 259px;
    height: 100%;
    padding: 14px 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 12px;
    color: var(--lightThemeFontColor);
    background: #fafafa;
    border: none;
    border-radius: 25px;
    overflow: hidden;

    @media (max-width: 768px) {
        width: 70px;
        min-width: 70px;
        padding: 10px 6px;
        border-radius: 25px;
        overflow-y: auto;
        overflow-x: hidden;
        margin-right: 5px;
        margin-left: -7px;
        //hide scrollbar
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none;  /* IE 10+ */
        ::-webkit-scrollbar { /* WebKit */
            width: 0;
            height: 0;
        }

    }
`
const SettingsWrap = styled.div`
    width: 100%;
    min-height: 0;
    flex: 1;
    text-align: center;
    color: var(--lightThemeFontColor); 
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar{
        display: none;
    }
`

const SettingsTitle = styled.div`
    display: block;
    text-align: left;
    padding-left: 10px;
    font-size: 20px;
    color: var(--fontColorGrey);
    font-family: 'Arial', sans-serif;
    margin: 4px 0 15px;
    @media (max-width: 768px) {
        text-align: center;
        padding-left: 5px;
        font-size: 14px;
        margin-bottom: 10px;
    }
`

const SettingsItemTitle = styled.div`
    padding-right: 10px;
    padding-left: 10px;
    @media (max-width: 768px) {
        display: none;
    }
`
